import { useState, useEffect } from "react";
import { getZoneById } from "../api/zone/zoneRequest";

export const useZoneDetails = (zoneId) => {
  const [zoneDetails, setZoneDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!zoneId) return;

    const fetchZoneDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getZoneById(zoneId);
        setZoneDetails(data.data);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch zone details");
      } finally {
        setLoading(false);
      }
    };

    fetchZoneDetails();
  }, [zoneId]);

  return { zoneDetails, loading, error };
};
